import { AES, enc } from 'crypto-js';
import Cookie from 'js-cookie';

import { ACCESS_TOKEN, CONFIRMATION_TOKEN, RESET_TOKEN, TOKEN, TWOFA_TOKEN } from '../constants';

interface LoginResponse {
	expiresIn: string;
	mode: string;
	token: string;
}

export const setCookie = (key: string, data: LoginResponse) => {
	const expirationDate = new Date(new Date().getTime() + Number(data?.expiresIn) * 1000);
	const encryptAccessToken = AES.encrypt(
		JSON.stringify(data),
		`${import.meta.env.VITE_API_SECRET_KEY ?? import.meta.env.VITE_API_CAPTCHA_KEY}`
	).toString();
	Cookie.set(key, encryptAccessToken, {
		sameSite: 'strict',
		path: '/',
		expires: expirationDate,
	});
};

export const removeCookie = () => {
	Cookie.remove(ACCESS_TOKEN);
	Cookie.remove(CONFIRMATION_TOKEN);
	Cookie.remove(RESET_TOKEN);
	Cookie.remove(TWOFA_TOKEN);
	Cookie.remove(TOKEN);
};

export const getCookie = (key: string = Cookie.get(ACCESS_TOKEN) as string) => {
	const cookie = Cookie.get(key);
	if (!cookie) {
		return null;
	}
	try {
		const decryptToken = JSON.parse(
			AES.decrypt(
				String(cookie),
				`${import.meta.env.VITE_API_SECRET_KEY ?? import.meta.env.VITE_API_CAPTCHA_KEY}`
			).toString(enc.Utf8)
		);
		return decryptToken;
	} catch (error) {
		console.error(error);
		return null;
	}
};

export const deleteCookie = (key: string) => {
	Cookie.remove(key);
};

export const getToken = (key = ACCESS_TOKEN) => {
	try {
		const decryptCookie = getCookie(key);
		return decryptCookie?.token;
	} catch (error) {
		console.error(error);
		return null;
	}
};

export const isTokenValid = (key = Cookie.get(ACCESS_TOKEN)) => {
	const cookieData = getCookie(key);
	return Boolean(cookieData && cookieData?.token);
};
